import React from 'react';

const Vision = () => {
  return (
    <section id="vision" className="section">
      <div className="container">
        <h2 className="section-title">Vision & Goals</h2>
        <blockquote className="vision-quote">
          As a Digital Marketing Lead and Full Stack Developer, I'm passionate about building scalable 
          digital solutions and driving growth through data-driven marketing. I see myself advancing 
          into strategic leadership roles where I can combine both skills to create greater impact.
        </blockquote>
        <div className="goals-grid">
          <div className="goal-card">
            <h3 className="goal-title">Short Term Goals</h3>
            <p>Master full-stack development and advanced digital marketing strategies</p>
          </div>
          <div className="goal-card">
            <h3 className="goal-title">Long Term Vision</h3>
            <p>Lead innovative teams that bridge technology and marketing for scalable business growth</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Vision;